import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, LogIn } from 'lucide-react';

const SessionTimeoutModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        {/* Backdrop */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
          onClick={onClose}
        />

        {/* Modal */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          className="relative bg-white rounded-xl shadow-2xl p-6 max-w-md w-full mx-4"
        >
          {/* Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-orange-600" />
            </div>
          </div>

          {/* Content */}
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Session Timed Out
            </h2>
            <p className="text-gray-600">
              Your session has expired due to inactivity. Please reauthenticate to continue.
            </p>
          </div>

          {/* Action Button */}
          <button
            onClick={onClose}
            className="w-full flex items-center justify-center space-x-2 bg-cobalt-600 hover:bg-cobalt-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            <LogIn className="w-5 h-5" />
            <span>Go to Login</span>
          </button>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default SessionTimeoutModal;
